import gql from 'graphql-tag';
import { DocumentNode } from 'graphql';

interface BuildVars {
  (shareablePageId: string): { shareablePageId: string };
}

interface GetShareablePageQuery {
  query: DocumentNode;
  module: string;
  buildVariables: BuildVars
}

const getShareablePageQuery = gql`
  query GetShareablePage($shareablePageId: String!) {
    getShareablePage(shareablePageId: $shareablePageId) {
      shareablePageId
      title
      description
      contents
      brandingColor
      allowCalendarLinks
      captionsEnabled
    }
  }
`;

const getSplashPage = (shareablePageId: string): GetShareablePageQuery => ({
  query: getShareablePageQuery,
  module: 'splash',
  buildVariables: () => ({ shareablePageId })
});

export default getSplashPage;
